import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-wrap gap-2 mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_RouterLink, {
      to: "/settings/account-settings",
      class: "px-4 py-2 text-sm font-medium text-slate-600 dark:text-slate-400 bg-slate-50 dark:bg-slate-800 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700 hover:text-slate-900 dark:hover:text-slate-100 transition-all duration-200 border border-slate-200 dark:border-slate-700"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.directT('settings.nav.accountSettings')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_RouterLink, {
      to: "/settings/change-password",
      class: "px-4 py-2 text-sm font-medium text-slate-600 dark:text-slate-400 bg-slate-50 dark:bg-slate-800 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700 hover:text-slate-900 dark:hover:text-slate-100 transition-all duration-200 border border-slate-200 dark:border-slate-700"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.directT('settings.nav.changePassword')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_RouterLink, {
      to: "/settings/connections",
      class: "px-4 py-2 text-sm font-medium text-slate-600 dark:text-slate-400 bg-slate-50 dark:bg-slate-800 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700 hover:text-slate-900 dark:hover:text-slate-100 transition-all duration-200 border border-slate-200 dark:border-slate-700"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.directT('settings.nav.connections')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_RouterLink, {
      to: "/settings/leads-settings",
      class: "hidden sm:inline-block px-4 py-2 text-sm font-medium text-slate-600 dark:text-slate-400 bg-slate-50 dark:bg-slate-800 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700 hover:text-slate-900 dark:hover:text-slate-100 transition-all duration-200 border border-slate-200 dark:border-slate-700"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.directT('settings.nav.leadsSettings')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_RouterLink, {
      to: "/settings/customers-settings",
      class: "hidden sm:inline-block px-4 py-2 text-sm font-medium text-slate-600 dark:text-slate-400 bg-slate-50 dark:bg-slate-800 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700 hover:text-slate-900 dark:hover:text-slate-100 transition-all duration-200 border border-slate-200 dark:border-slate-700"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.directT('settings.nav.customersSettings')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_RouterLink, {
      to: "/settings/deals-settings",
      class: "hidden sm:inline-block px-4 py-2 text-sm font-medium text-slate-600 dark:text-slate-400 bg-slate-50 dark:bg-slate-800 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700 hover:text-slate-900 dark:hover:text-slate-100 transition-all duration-200 border border-slate-200 dark:border-slate-700"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.directT('settings.nav.dealsSettings')), 1)
      ]),
      _: 1
    })
  ]))
}